import React, { useState, useEffect, useRef } from "react";
import useEffectAsync, {
  useMountedState,
  useInterval
} from "lib/react/customHooks";
import { makeStyles, Box } from "@material-ui/core";
import { getAthenaTenants } from "lib/services/athenaTenants";
import AddAthenaTenantComponent from "./AddAthenaTenantComponent";
import AthenaTenantsTable from "./AthenaTenantsTable";

const useStyles = makeStyles(() => ({
  mainContent: {
    padding: "40px 80px"
  },
  actionsContainer: {
    display: "flex",
    justifyContent: "flex-end"
  },
  actionButtonsContainer: {
    display: "flex",
    flexDirection: "row-reverse"
  },
  tableContainer: {
    marginTop: "10px"
  }
}));

// eslint-disable-next-line react/prop-types
export default function AthenaTenantsComponent() {
  const classes = useStyles();
  const [athenaTenants, setAthenaTenants] = useMountedState([]);
  const savedAthenaTenants = useRef(null);
  const [refreshTableKey, setRefreshTableKey] = useState(0);

  const refreshTable = () => {
    setRefreshTableKey(refreshTableKey + 1);
  };

  const updateAndSetAthenaTenantState = async () => {
    const response = await getAthenaTenants();
    if (
      savedAthenaTenants.current === null ||
      savedAthenaTenants.current.length !== response.data.length
    ) {
      setAthenaTenants(response.data);
    }
  };

  // We save the previous state so we can compare always the result when the polling system is updated
  useEffect(() => {
    savedAthenaTenants.current = athenaTenants;
  }, [athenaTenants]);

  useEffectAsync(
    async () => {
      const response = await getAthenaTenants();
      return response.data;
    },
    athenaTenantsResponse => {
      setAthenaTenants(athenaTenantsResponse);
    },
    []
  );

  useInterval(() => {
    updateAndSetAthenaTenantState();
  }, 10000);

  return (
    <div className={classes.mainContent}>
      <Box component="div" className={classes.actionsContainer}>
        <Box component="div" className={classes.actionButtonsContainer}>
          <AddAthenaTenantComponent
            onSuccess={refreshTable}
            athenaTenants={athenaTenants}
          />
        </Box>
      </Box>
      <Box component="div" className={classes.tableContainer}>
        <AthenaTenantsTable
          refreshKey={refreshTableKey}
          athenaTenants={athenaTenants}
        />
      </Box>
    </div>
  );
}
